module.exports = (__webpack_require__(87143))(1248);